import { render, staticRenderFns } from "./CategoryEditableCell.vue?vue&type=template&id=2b3fda69&scoped=true"
import script from "./CategoryEditableCell.vue?vue&type=script&lang=js"
export * from "./CategoryEditableCell.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditableCell.vue?vue&type=style&index=0&id=2b3fda69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3fda69",
  null
  
)

export default component.exports